import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import './ProductPage.css';

// For demo, use the same products array as ProductsPage
const products = [
  {
    id: 'chroniq',
    image: '/logo_chroniq.png',
    title: 'Chroniq: Listen to the Past Come Alive',
    category: '',
    appLink: '',
    description: '',
    rating: 0,
    age: '',
    language: '',
    size: '',
    isPWA: true,
    gallery: [
      '/chroniq_image1.jpg',
      '/chroniq_image2.jpg',
      '/chroniq_image3.jpg',
      '/chroniq_image4.jpg',
    ],
    buyNowLink: '',
    about: `Turn your downtime into discovery with Chroniq — the immersive audio app that brings history to life through sound and storytelling.

EXPLORE. LISTEN. FEEL.
Step into ancient worlds, forgotten empires, and moments that shaped humanity. Choose from 25+ expertly narrated stories, each paired with rich ambient soundscapes — vinyl, piano, and more — to make every listen deeply atmospheric.

YOUR JOURNEY, YOUR PACE
• Pause anytime and resume where you left off
• Listen offline or on the go
• Choose your perfect sound backdrop
• Save favorites and build your personal library of time-travel tales

RECONNECT WITH HISTORY
Whether you’re winding down, walking, or searching for inspiration, Chroniq turns every moment into an intimate journey through the past — calming, thought-provoking, and unforgettable.

Join thousands of listeners rediscovering the world through sound.`
  },
  {
    id: 'sipless',
    image: '/logo_sipless.webp',
    title: 'Sipless',
    category: 'Lifestyle',
    appLink: 'https://apps.apple.com/ua/app/sipless-sobriety-tracker/id6737804753',
    description: '',
    age: '18+',
    language: 'EN',
    size: '105MB',
    isPWA: false,
    gallery: [
      '/sipless1.webp',
      '/sipless2.webp',
      '/sipless3.webp',
      '/sipless4.webp',
    ],
    buyNowLink: '',
    about: `The Sipless app is the easy way to break free from alcohol. Simply track your clean days to start your sobriety streak. Build a lasting habit to stay sober for weeks, months, or even years. See how much money you spend on drinks and make the right choice for you. It’s time to sip less and enjoy life more. 

WHAT YOU GET WITH SIPLESS 

▶ Enjoy a better mood without hangovers or headaches
▶ Boost your overall well-being day by day
▶ Save more money by cutting out drinks
▶ Perform better at work or in your studies with more focus
▶ Gain extra time for yourself, friends, and family
▶ Improve your health and potentially lose weight
▶ Stay motivated to cut down or quit drinking

KEY SIPLESS FEATURES

▶  Track your clean days 
All you need is literally two seconds to start your sobriety streak. Sipless lets you log every drink or alcohol-free day, helping you keep an accurate calendar of your progress. Each day adds up, making it easier for you to stay committed to your goals.
▶ Calculate your savings
One of the best motivators to quit drinking is the amount of money you’ll save. Sipless includes an automatic calculator to track the total average cost of your drinks, showing you exactly how much you could have saved with every dry day.
▶ Set goals and stay accountable
Whether it’s cutting down on casual drinking or going alcohol-free, set your goals and track your progress with our sobriety tracker. Sipless keeps you focused, motivating you to continue and hit new sober milestones.
▶ Challenge yourself
Can you go longer without alcohol? Sipless will track your sobriety streaks and support you on responding to every challenge - whether it’s Dry January, Sober October, or a lifelong commitment to sobriety.
▶ Get help to quit drinking
You’re not alone. Sipless is here to assist you every step of the way. Get the sobriety counter, savings calculator, daily motivation, and clean day calendar  - all in one app.
Sipless is your recovery buddy. Get everything you need to quit drinking and embrace a healthier, happier life. Track your days, calculate your savings, and stay motivated to get rid of your alcohol addiction. `
  }
];

const ProductPage = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const product = products.find(p => p.id === productId);

  // Use gallery images from the product object
  const galleryImages = product ? product.gallery : [];

  if (!product) {
    return (
      <div className="products-page">
        <Header />
        <main className="products-main">
          <h2>Product not found</h2>
          <button onClick={() => navigate('/products')}>Back to Products</button>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <>
      <Header />
      <main className="product-main-detail">
        <div className="product-detail-layout">
          {/* Main Card */}
          <div className="product-detail-maincard">
            {/* Logo and Title */}
            <div className="product-detail-logo-title">
              <img src={product.image} alt={product.title} className="product-detail-logo" />
              <h1 className="product-detail-title">{product.title}</h1>
            </div>
            {/* Meta Row - Hidden for PWA apps */}
            {!product.isPWA && (
              <div className="product-detail-meta-row">
              {/* //   <div className="product-detail-meta-col">
              //     <div className="meta-label">Rating</div>
              //     <div className="meta-value">{product.rating}</div>
              //   </div> */}
                <div className="product-detail-meta-col">
                  <div className="meta-label">Category</div>
                  <div className="meta-value">{product.category}</div>
                </div>
                <div className="product-detail-meta-col">
                  <div className="meta-label">Age</div>
                  <div className="meta-value">{product.age}</div>
                </div>
                <div className="product-detail-meta-col">
                  <div className="meta-label">Language</div>
                  <div className="meta-value">{product.language}</div>
                </div>
                <div className="product-detail-meta-col">
                  <div className="meta-label">Size</div>
                  <div className="meta-value">{product.size}</div>
                </div>
              </div>
            )}
            {/* Gallery */}
            <div className="product-detail-gallery">
              {galleryImages.map((img, idx) => (
                <div className="product-detail-gallery-img" key={img}>
                  <img src={img} alt={`${product.title} screenshot ${idx+1}`} style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '12px'}} />
                </div>
              ))}
            </div>
            {/* About the app section */}
            <section className="product-detail-about">
              <br/>
              <h2>About the app:</h2>
              <div className="product-detail-about-content">
                {product.about ? product.about.split('\n').map((line, i) => (
                  line.trim().startsWith('-') ? <li key={i}>{line.replace(/^[-•]\s*/, '')}</li>
                  : line.trim() === '' ? <br key={i} />
                  : <p key={i}>{line}</p>
                )) : <p>{product.description}</p>}
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ProductPage;
